import AuthenticatorResource from "../../resources/authenticator-resource"

export const makeAuthenticatorResource = (): AuthenticatorResource => {
    return new AuthenticatorResource()
}
